"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTMLArea = exports.HTMLAreaField = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var bowser_1 = __importDefault(require("bowser"));
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
require("quill/dist/quill.snow.css");
var React = __importStar(require("react"));
var fieldMaker_1 = require("../fieldMaker");
require("./htmlarea.css");
var HTMLAreaField = /** @class */ (function (_super) {
    __extends(HTMLAreaField, _super);
    function HTMLAreaField(props) {
        var _this = _super.call(this, props) || this;
        _this.wrapperRef = React.createRef();
        _this.editorRef = React.createRef();
        _this.initialContent = (0, function_1.pipe)(O.fromNullable(_this.props.value), O.getOrElse(function () { return ''; }));
        _this.onChange = function (html) { return _this.props.onChange && _this.props.onChange(html, html); };
        var browser = bowser_1.default.getParser(window.navigator.userAgent);
        _this.isInbrowserUnsuported = browser.satisfies({
            ie: '<11',
            firefox: '<59',
            chrome: '<66',
            safari: '<10.12',
        })
            ? true
            : false;
        return _this;
    }
    HTMLAreaField.prototype.componentDidMount = function () {
        var _this = this;
        var options = {
            modules: {
                toolbar: this.props.toolbar,
            },
            placeholder: this.props.placeholder,
            theme: 'snow',
            bounds: this.wrapperRef.current,
            scrollingContainer: this.editorRef.current,
            readOnly: (0, function_1.pipe)(O.fromNullable(this.props.disabled), O.getOrElse(function () { return false; })),
        };
        if (!this.isInbrowserUnsuported) {
            Promise.resolve().then(function () { return __importStar(require('quill')); }).then(function (_a) {
                var Quill = _a.default;
                var quill = new Quill(_this.editorRef.current, options);
                quill.root.innerHTML = (0, function_1.pipe)(O.fromNullable(_this.props.value), O.getOrElse(function () { return ''; }));
                quill.on('text-change', function () {
                    _this.onChange(quill.root.innerHTML);
                });
            });
        }
    };
    HTMLAreaField.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "htmlarea", ref: this.wrapperRef }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "html-editor", ref: this.editorRef, style: {
                    height: (0, function_1.pipe)(O.fromNullable(this.props.height), O.getOrElse(function () { return '250px'; })),
                } }, { children: this.isInbrowserUnsuported ? ' Browser non supportato ' : null })) })));
    };
    return HTMLAreaField;
}(React.PureComponent));
exports.HTMLAreaField = HTMLAreaField;
exports.HTMLArea = (0, fieldMaker_1.makeField)(HTMLAreaField);
//# sourceMappingURL=HTMLArea.js.map